import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { AuthProvider } from "./auth.js";
import { ThemeProvider } from "./ui.js";
import "./theme.css";
import "./brand.css";

const container = document.getElementById("root");
if (!container) throw new Error("root element missing");

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeProvider>
  </StrictMode>,
);

// Register the PWA service worker (installable + offline shell). Best-effort.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" })
      .then((registration) => {
        // Ask the browser to check on every app load. The versioned cache in
        // sw.js ensures an updated shell cannot be served indefinitely.
        void registration.update().catch(() => undefined);
      })
      .catch(() => undefined);
  });
}
